module.exports = __webpack_public_path__ + "img/invite-coordinator.82f5b9ac.svg";